import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./EquivalentSecuritiesDrawer.module.css";

interface Props {
  ticker: string;
  description: string;
}

const EquivalentSecuritiesDrawerTableRow: React.FC<Props> = ({
  ticker,
  description,
}) => {
  return (
    <div className={styles.row}>
      <Text className={styles.rowCol1} variant="title3">
        {ticker}
      </Text>

      <Text color="textSubtle" variant="body">
        {description}
      </Text>
    </div>
  );
};

export default EquivalentSecuritiesDrawerTableRow;
